import React from "react";
//#region types
import { SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { InvoiceStepProps } from "models/propTypes/customerImportPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { HorizontalFormField, SelectInput, WizardSection } from "components/common/wintForms";
//#endregion
import { CsvImportHelper, LocalizationHelperInstance } from "utils/helpers";

const InvoiceStep: React.FC<InvoiceStepProps> = ({ connect, headersObject, submitted, wizardProps }) => {
  return (
    <WizardSection header={TranslationKeys.Common.Invoicing} submitted={submitted} wizardProps={wizardProps}>
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("vatNumberColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.VATNr)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.VATNr)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("glnNumberColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.GlnNr)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.GlnNr)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("includeVatNumberOnInvoiceColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.IncludeVatNumberOnInvoice
        )}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.IncludeVatNumberOnInvoice)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportIncludeVATNumberDescription
        )}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("customerStandardPaymentTermsColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.StandardPaymentTerms)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.StandardPaymentTerms)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportPaymentTermsDescription
        )}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("showCurrencyCodeColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportShowCurrencyCode)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportShowCurrencyCode)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportShowCurrencyCodeDescription
        )}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("languageColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportLanguage)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportLanguage)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Customer.ImportLanguageDescription
        )}
        items={headersObject}
        optional
      />
    </WizardSection>
  );
};

export default InvoiceStep;
